export type PlayerGps = { lat: number; lng: number; accuracy?: number }

export function watchPlayerGps(
  onUpdate: (gps: PlayerGps | null) => void
): () => void {
  if (!navigator.geolocation) {
    onUpdate(null)
    return () => {}
  }
  const id = navigator.geolocation.watchPosition(
    (pos) => {
      onUpdate({
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
        accuracy: pos.coords.accuracy,
      })
    },
    () => onUpdate(null),
    { enableHighAccuracy: true, maximumAge: 5000, timeout: 15000 }
  )
  return () => navigator.geolocation.clearWatch(id)
}

export async function getPlayerGpsOnce(): Promise<PlayerGps | null> {
  if (!navigator.geolocation) return null
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (pos) =>
        resolve({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
        }),
      () => resolve(null),
      { enableHighAccuracy: true, timeout: 12000, maximumAge: 0 }
    )
  })
}
